'use client'

import { useState } from 'react'
import { ArrowUpRight } from 'lucide-react'
import { cn } from 'cn'
import { Link } from '@/components/site/link'
import { IndustryStreams } from './industry-streams'

export type IndustryEntry = { name: string; caseStudy?: { label: string; href: string } }

/**
 * The twelve industries as a numbered index. A cell links to its case study
 * when one exists; hovering or focusing a cell lights its stream in the
 * dither art that sits on top of the grid.
 */
export function IndustryIndex({ items }: { items: IndustryEntry[] }) {
  const [active, setActive] = useState<number | null>(null)
  return (
    <div className="home-industry-wrap">
      <IndustryStreams active={active} />
      <ol className="home-industry-index" onPointerLeave={() => setActive(null)}>
        {items.map((item, i) => (
          <li
            key={item.name}
            className={cn('home-industry-cell', active === i && 'active')}
            onPointerEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onBlur={() => setActive(null)}
          >
            <span className="home-industry-num" aria-hidden="true">
              {String(i + 1).padStart(2, '0')}
            </span>
            <span className="home-industry-name">{item.name}</span>
            {item.caseStudy ? (
              <Link href={item.caseStudy.href} className="home-industry-case">
                {item.caseStudy.label}
                <ArrowUpRight size={14} strokeWidth={2} aria-hidden="true" />
              </Link>
            ) : null}
          </li>
        ))}
      </ol>
    </div>
  )
}
